export const ENTITY_NAME = 'ADMIN_MANAGER_'
export const LOAD_LIST_TABS = "LOAD_LIST_TABS"
export const LOAD_TABS_DATA = "LOAD_TABS_DATA"
export const SET_TAB_ADMIN_MANAGER = "SET_TAB_ADMIN_MANAGER"
export const SET_SISTEM_ID_ADMIN_MANAGER = "SET_SISTEM_ID_ADMIN_MANAGER"